export default "__VITE_ASSET__ApIWkh9S__"